'use strict';

let theme = {

    init: function () {

        this.mainNavigation();
        this.stickyMainNavigation();
        this.scrollCue();
        this.swiperSlider();
        this.smoothScrollToTop();
    },

    mainNavigation: () => {
        const nav = document.querySelector('.main-nav');
        const menuToggle = document.querySelector('.menu-toggle');

        if (!nav || !menuToggle) {
            return;
        }

        const mobileBreakpoint = window.matchMedia('(max-width: 800px)');

        menuToggle.setAttribute('aria-expanded', 'false');
        menuToggle.addEventListener('click', () => {
            const isOpen = nav.classList.toggle('main-nav--open');
            menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });

        const submenuItems = nav.querySelectorAll('.menu-item-has-children');
        submenuItems.forEach((item) => {
            const toggle = item.querySelector(':scope > .main-nav__submenu-toggle');
            if (!toggle) {
                return;
            }

            toggle.addEventListener('click', (event) => {
                if (!mobileBreakpoint.matches) {
                    return;
                }

                event.preventDefault();
                const isOpen = item.classList.toggle('is-open');
                toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            });
        });
    },

    stickyMainNavigation: () => {
        const nav = document.querySelector('.main-nav');
        if (!nav) {
            return;
        }

        const hero = document.querySelector('.hero');
        const topbar = document.querySelector('.topbar');

        let triggerOffset = 0;

        const syncNavHeight = () => {
            document.documentElement.style.setProperty('--sticky-main-nav-height', `${nav.offsetHeight}px`);
        };

        const computeTriggerOffset = () => {
            if (hero) {
                triggerOffset = hero.offsetTop + hero.offsetHeight;
                return;
            }

            if (topbar) {
                triggerOffset = topbar.offsetTop + topbar.offsetHeight;
                return;
            }

            triggerOffset = nav.offsetTop;
        };

        const updateStickyState = () => {
            const shouldStick = window.scrollY >= triggerOffset;
            nav.classList.toggle('main-nav--sticky', shouldStick);
            document.body.classList.toggle('has-sticky-main-nav', shouldStick);
        };

        const refreshStickyMetrics = () => {
            syncNavHeight();
            computeTriggerOffset();
            updateStickyState();
        };

        window.addEventListener('resize', refreshStickyMetrics);
        window.addEventListener('scroll', updateStickyState, {passive: true});
        window.addEventListener('load', refreshStickyMetrics);

        refreshStickyMetrics();
    },

    /**
     * Sub Menus
     * Enables multilevel dropdown
     */
    subMenu: () => {
        (function ($bs) {
            const CLASS_NAME = 'has-child-dropdown-show';
            $bs.Dropdown.prototype.toggle = function (_original) {
                return function () {
                    document.querySelectorAll('.' + CLASS_NAME).forEach(function (e) {
                        e.classList.remove(CLASS_NAME);
                    });
                    let dd = this._element.closest('.dropdown').parentNode.closest('.dropdown');
                    for (; dd && dd !== document; dd = dd.parentNode.closest('.dropdown')) {
                        dd.classList.add(CLASS_NAME);
                    }
                    return _original.call(this);
                }
            }($bs.Dropdown.prototype.toggle);
            document.querySelectorAll('.dropdown').forEach(function (dd) {
                dd.addEventListener('hide.bs.dropdown', function (e) {
                    if (this.classList.contains(CLASS_NAME)) {
                        this.classList.remove(CLASS_NAME);
                        e.preventDefault();
                    }
                    e.stopPropagation();
                });
            });
        })(bootstrap);
    },

    scrollCue: () => {
        scrollCue.init({
            interval: -400,
            duration: 700,
            percentage: 0.8
        });
        scrollCue.update();
    },
    /**
     * Swiper Slider
     * Enables carousels and sliders
     * Requires assets/js/vendor/swiper-bundle.min.js
     */
    swiperSlider: function () {

        const partnersClients = document.querySelector('.swiper-partners-clients');

        if (partnersClients && typeof Swiper !== 'undefined') {
            try {
                const swiper = new Swiper(".swiper-partners-clients", {
                    slidesPerView: 3,
                    spaceBetween: 60,
                    loop: true,
                    centeredSlides: false,
                    autoplay: {
                        delay: 0,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: false,
                        reverseDirection: false
                    },
                    speed: 5000,
                    freeMode: {
                        enabled: true,
                        momentum: false,
                    },
                    allowTouchMove: false,
                    grabCursor: false,
                    breakpoints: {
                        480: {
                            slidesPerView: 6,
                            spaceBetween: 50,
                        },
                        768: {
                            slidesPerView: 7
                        },
                        1200: {
                            slidesPerView: 8
                        },
                        1920: {
                            slidesPerView: 12
                        }
                    },
                });
            } catch (error) {
                console.error('Error initializing Swiper:', error);
            }
        }


        // Initialize news swiper
        const swiperNewsElement = document.querySelector('.swiper-news');

        if (swiperNewsElement && typeof Swiper !== 'undefined') {
            try {
                const swiperNews = new Swiper('.swiper-news', {
                    slidesPerView: 1,
                    spaceBetween: 24,
                    loop: false,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 30,
                        }
                    }
                });
            } catch (error) {
                console.error('Error initializing News Swiper:', error);
            }
        }


        // Initialize training overview Swiper
        const trainingOverviewElement = document.querySelector('.training-overview.swiper-container');

        if (trainingOverviewElement && typeof Swiper !== 'undefined') {
            try {
                const trainingSwiper = new Swiper('.training-overview.swiper-container', {
                    slidesPerView: 'auto',
                    spaceBetween: 20,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    scrollbar: {
                        el: '.swiper-scrollbar',
                        draggable: true,
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 30,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 40,
                        },
                    },
                });
            } catch (error) {
                console.error('Error initializing Training Overview Swiper:', error);
            }
        }


        // Initialize LinkedIn Swiper
        const swiperLinkedInFeed = document.querySelector('.swiper-linkedin-feed');

        if (swiperLinkedInFeed && typeof Swiper !== 'undefined') {
            try {
                const swiperLinkedInFeed = new Swiper('.swiper-linkedin-feed', {
                    slidesPerView: 1,
                    spaceBetween: 24,
                    loop: false,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                        992: {
                            slidesPerView: 3,
                            spaceBetween: 30,
                        }
                    }
                });
            } catch (error) {
                console.error('Error initializing News Swiper:', error);
            }
        }

    },


    smoothScrollToTop: function () {
        document.addEventListener('DOMContentLoaded', function () {
            const scrollToTopButton = document.getElementById('scrollToTop');

            if (!scrollToTopButton) return;

            scrollToTopButton.addEventListener('click', () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });

            window.addEventListener('scroll', () => {
                if (window.scrollY > 300) {
                    scrollToTopButton.classList.add('visible');
                } else {
                    scrollToTopButton.classList.remove('visible');
                }
            });
        });
    },

    /**
     * GLightbox
     * Enables lightbox functionality
     * Requires assets/js/vendor/glightbox.js
     */

    lightbox: () => {
        const lightbox = GLightbox({
            selector: '*[data-glightbox]',
            touchNavigation: true,
            loop: false,
            zoomable: false,
            autoplayVideos: true,
            moreLength: 0,
            slideExtraAttributes: {
                poster: ''
            },
            plyr: {
                css: '',
                js: '',
                config: {
                    ratio: '',
                    fullscreen: {
                        enabled: false,
                        iosNative: false
                    },
                    youtube: {
                        noCookie: true,
                        rel: 0,
                        showinfo: 0,
                        iv_load_policy: 3
                    },
                    vimeo: {
                        byline: false,
                        portrait: false,
                        title: false,
                        transparent: false
                    }
                }
            },
        });
    },

}
theme.init();
